// import "./Login1.css";
// import { useState } from "react";
// import { IoLockOpen, IoLockClosed } from "react-icons/io5";
// import { FaUser } from "react-icons/fa";
// import bike from "../../Assets/Images/LOGO.png"
// import logo from "../../Assets/Images/LOGO.jfif"
// // import Aslogistics from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import ShreeRamLogo from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import AGLlogo from "../../Assets/Images/Clientlogo/Agl_logo.png"
// import Tsslogo from "../../Assets/Images/Clientlogo/Tsslogo.png"

// import Swal from "sweetalert2";
// import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//     const navigate = useNavigate();
//     const [login, setLogin] = useState(true);
//     const [lock, setLock] = useState(true);
    
//     const [formData, setFormData] = useState({ userName: "", password: "" });
//     const handleSaveLogin = async (e) => {
//         e.preventDefault();

//         const { userName, password } = formData;

//         if (!userName || !password) {
//             Swal.fire("Error", "Username and Password are required", "error");
//             return;
//         }

//         try {
//             const response = await getApi(
//                 `/Master/UserContllor?UserName=${encodeURIComponent(
//                     userName
//                 )}&Password=${encodeURIComponent(password)}`
//             );

//             if (response.status === 1) {
//                 Swal.fire({
//           title: "Success",
//           text: "Login successful!",
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500
//         });
//                 localStorage.setItem("Login", JSON.stringify(response.userData));

//                 // ✅ HASHROUTER SAFE
//                 navigate("/dashboard");
//             } else {
//                 Swal.fire("Error", "Invalid credentials", "error");
//             }
//         } catch (err) {
//             console.error("Login Error:", err);
//             Swal.fire(
//                 "Error",
//                 "Invalid username or password. Please try again.",
//                 "error"
//             );
//         }
//     };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//     };
//     return (
//         <div className="contain" key={login}>
//             <div className="left ">
//                 <img src={Tsslogo} alt="" className="logo animate-left" />
//                 <div className="bike animate-left"><img src={bike} alt="" />
//                 </div>
//                 <div className="logo-secion animate-left">
//                     <div className="logo-name">TRACK N TRACK COUIRER SERVICES</div>
//                     <div className="logo-text">Track N Track Courier Services is a next-gen tech-driven express and
//                         e-commerce Logistics solution provider.</div>
//                 </div>
//             </div>
//             <div className="right">
                
//                 <div className="form-page">
//                     <div className="mobile-logo animate-rtl">
//         <img src={Tsslogo} alt="Logo" />
//     </div>
//                     <div className="tital animate-rtl">{login ? "Login Page" : "Signup Page"}</div>
//                     <form className="form"
//                         onSubmit={(e) => {
//                             e.preventDefault();
//                             if (login) {
//                                 handleSaveLogin(e);
//                             }
//                         }}
//                     >
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="user">User Name</label>
//                             <input type="text" id="userName" name="userName" placeholder="Enter User name"
//                                 value={formData.userName}
//                                 onChange={handleInputChange} />
//                             <FaUser className="userLogo" />
//                         </div>
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="pass">Password</label>
//                             <input type={!lock ? "text" : "password"} id="password" name="password" placeholder="Enter Password"
//                                 value={formData.password}
//                                 onChange={handleInputChange} />
//                             <div onClick={() => setLock(p => !p)}>{!lock ? <IoLockOpen className="passLogo" /> :
//                                 <IoLockClosed className="passLogo" />}</div>
//                         </div>
//                         <button className="animate-rtl button" >{login ? "Login" : "Signup"}</button>
//                     </form>
//                     <div className="account">{login ? "Don't have an account ?" : "Already Registered ?"}
//                         <span onClick={() => setLogin((p) => !p)}>{login ? "Signup" : "Login"}</span></div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Login


// =========================================Bw World Login Page ======================================


// import "./Login1.css";
// import { useState } from "react";
// import { IoLockOpen, IoLockClosed } from "react-icons/io5";
// import { FaUser } from "react-icons/fa";
// import bike from "../../Assets/Images/LOGO.png"
// import logo from "../../Assets/Images/LOGO.jfif"
// // import Aslogistics from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import ShreeRamLogo from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import AGLlogo from "../../Assets/Images/Clientlogo/Agl_logo.png"
// import BsLogo from "../../Assets/Images/Clientlogo/Bsworlwidelogo.png"

// import Swal from "sweetalert2";
// import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//     const navigate = useNavigate();
//     const [login, setLogin] = useState(true);
//     const [lock, setLock] = useState(true);
    
//     const [formData, setFormData] = useState({ userName: "", password: "" });
//     const handleSaveLogin = async (e) => {
//         e.preventDefault();

//         const { userName, password } = formData;

//         if (!userName || !password) {
//             Swal.fire("Error", "Username and Password are required", "error");
//             return;
//         }

//         try {
//             const response = await getApi(
//                 `/Master/UserContllor?UserName=${encodeURIComponent(
//                     userName
//                 )}&Password=${encodeURIComponent(password)}`
//             );

//             if (response.status === 1) {
//                 Swal.fire({
//           title: "Success",
//           text: "Login successful!",
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500
//         });
//                 localStorage.setItem("Login", JSON.stringify(response.userData));

//                 // ✅ HASHROUTER SAFE
//                 navigate("/dashboard");
//             } else {
//                 Swal.fire("Error", "Invalid credentials", "error");
//             }
//         } catch (err) {
//             console.error("Login Error:", err);
//             Swal.fire(
//                 "Error",
//                 "Invalid username or password. Please try again.",
//                 "error"
//             );
//         }
//     };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//     };
//     return (
//         <div className="contain" key={login}>
//             <div className="left ">
//                 <img src={BsLogo} alt="" className="logo animate-left" />
//                 <div className="bike animate-left"><img src={bike} alt="" />
//                 </div>
//                 <div className="logo-secion animate-left">
//                     <div className="logo-name">B. S. Worldwide Express</div>
//                     <div className="logo-text">B. S. Worldwide Express is a next-gen tech-driven express and
//                         e-commerce Logistics solution provider.</div>
//                 </div>
//             </div>
//             <div className="right">
                
//                 <div className="form-page">
//                     <div className="mobile-logo animate-rtl">
//         <img src={BsLogo} alt="Logo" />
//     </div>
//                     <div className="tital animate-rtl">{login ? "Login Page" : "Signup Page"}</div>
//                     <form className="form"
//                         onSubmit={(e) => {
//                             e.preventDefault();
//                             if (login) {
//                                 handleSaveLogin(e);
//                             }
//                         }}
//                     >
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="user">User Name</label>
//                             <input type="text" id="userName" name="userName" placeholder="Enter User name"
//                                 value={formData.userName}
//                                 onChange={handleInputChange} />
//                             <FaUser className="userLogo" />
//                         </div>
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="pass">Password</label>
//                             <input type={!lock ? "text" : "password"} id="password" name="password" placeholder="Enter Password"
//                                 value={formData.password}
//                                 onChange={handleInputChange} />
//                             <div onClick={() => setLock(p => !p)}>{!lock ? <IoLockOpen className="passLogo" /> :
//                                 <IoLockClosed className="passLogo" />}</div>
//                         </div>
//                         <button className="animate-rtl button" >{login ? "Login" : "Signup"}</button>
//                     </form>
//                     <div className="account">{login ? "Don't have an account ?" : "Already Registered ?"}
//                         <span onClick={() => setLogin((p) => !p)}>{login ? "Signup" : "Login"}</span></div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Login

// =====================================AGL LOGIN PAGE ======================================================




// import "./Login1.css";
// import { useState } from "react";
// import { IoLockOpen, IoLockClosed } from "react-icons/io5";
// import { FaUser } from "react-icons/fa";
// import bike from "../../Assets/Images/LOGO.png"
// import logo from "../../Assets/Images/LOGO.jfif"
// // import Aslogistics from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import ShreeRamLogo from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// import AGLlogo from "../../Assets/Images/Clientlogo/Agl_logo.png"
// // import BsLogo from "../../Assets/Images/Clientlogo/Bsworlwidelogo.png"

// import Swal from "sweetalert2";
// import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//     const navigate = useNavigate();
//     const [login, setLogin] = useState(true);
//     const [lock, setLock] = useState(true);
    
//     const [formData, setFormData] = useState({ userName: "", password: "" });
//     const handleSaveLogin = async (e) => {
//         e.preventDefault();

//         const { userName, password } = formData;

//         if (!userName || !password) {
//             Swal.fire("Error", "Username and Password are required", "error");
//             return;
//         }

//         try {
//             const response = await getApi(
//                 `/Master/UserContllor?UserName=${encodeURIComponent(
//                     userName
//                 )}&Password=${encodeURIComponent(password)}`
//             );

//             if (response.status === 1) {
//                 Swal.fire({
//           title: "Success",
//           text: "Login successful!",
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500
//         });
//                 localStorage.setItem("Login", JSON.stringify(response.userData));

//                 // ✅ HASHROUTER SAFE
//                 navigate("/dashboard");
//             } else {
//                 Swal.fire("Error", "Invalid credentials", "error");
//             }
//         } catch (err) {
//             console.error("Login Error:", err);
//             Swal.fire(
//                 "Error",
//                 "Invalid username or password. Please try again.",
//                 "error"
//             );
//         }
//     };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//     };
//     return (
//         <div className="contain" key={login}>
//             <div className="left ">
//                 <img src={AGLlogo} alt="" className="logo animate-left" />
//                 <div className="bike animate-left"><img src={bike} alt="" />
//                 </div>
//                 <div className="logo-secion animate-left">
//                     <div className="logo-name">ARHAT GLOBAL LOGISTICS PRIVATE LIMITED</div>
//                     <div className="logo-text">Arhat Global Logistics Private Limited is a next-gen tech-driven express and
//                         e-commerce Logistics solution provider.</div>
//                 </div>
//             </div>
//             <div className="right">
                
//                 <div className="form-page">
//                     <div className="mobile-logo animate-rtl">
//         <img src={AGLlogo} alt="Logo" />
//     </div>
//                     <div className="tital animate-rtl">{login ? "Login Page" : "Signup Page"}</div>
//                     <form className="form"
//                         onSubmit={(e) => {
//                             e.preventDefault();
//                             if (login) {
//                                 handleSaveLogin(e);
//                             }
//                         }}
//                     >
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="user">User Name</label>
//                             <input type="text" id="userName" name="userName" placeholder="Enter User name"
//                                 value={formData.userName}
//                                 onChange={handleInputChange} />
//                             <FaUser className="userLogo" />
//                         </div>
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="pass">Password</label>
//                             <input type={!lock ? "text" : "password"} id="password" name="password" placeholder="Enter Password"
//                                 value={formData.password}
//                                 onChange={handleInputChange} />
//                             <div onClick={() => setLock(p => !p)}>{!lock ? <IoLockOpen className="passLogo" /> :
//                                 <IoLockClosed className="passLogo" />}</div>
//                         </div>
//                         <button className="animate-rtl button" >{login ? "Login" : "Signup"}</button>
//                     </form>
//                     <div className="account">{login ? "Don't have an account ?" : "Already Registered ?"}
//                         <span onClick={() => setLogin((p) => !p)}>{login ? "Signup" : "Login"}</span></div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Login




// ===================================TRACK N TRACK COURIER ================================


// import "./Login1.css";
// import { useState } from "react";
// import { IoLockOpen, IoLockClosed } from "react-icons/io5";
// import { FaUser } from "react-icons/fa";
// import bike from "../../Assets/Images/LOGO.png"
// import logo from "../../Assets/Images/LOGO.jfif"
// // import Aslogistics from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import ShreeRamLogo from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// // import AGLlogo from "../../Assets/Images/Clientlogo/Agl_logo.png"
// import Tsslogo from "../../Assets/Images/Clientlogo/Tsslogo.png"

// import Swal from "sweetalert2";
// import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
// import { useNavigate } from "react-router-dom";
// const Login = () => {
//     const navigate = useNavigate();
//     const [login, setLogin] = useState(true);
//     const [lock, setLock] = useState(true);
    
//     const [formData, setFormData] = useState({ userName: "", password: "" });
//     const handleSaveLogin = async (e) => {
//         e.preventDefault();

//         const { userName, password } = formData;

//         if (!userName || !password) {
//             Swal.fire("Error", "Username and Password are required", "error");
//             return;
//         }

//         try {
//             const response = await getApi(
//                 `/Master/UserContllor?UserName=${encodeURIComponent(
//                     userName
//                 )}&Password=${encodeURIComponent(password)}`
//             );

//             if (response.status === 1) {
//                 Swal.fire({
//           title: "Success",
//           text: "Login successful!",
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500
//         });
//                 localStorage.setItem("Login", JSON.stringify(response.userData));

//                 // ✅ HASHROUTER SAFE
//                 navigate("/dashboard");
//             } else {
//                 Swal.fire("Error", "Invalid credentials", "error");
//             }
//         } catch (err) {
//             console.error("Login Error:", err);
//             Swal.fire(
//                 "Error",
//                 "Invalid username or password. Please try again.",
//                 "error"
//             );
//         }
//     };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({ ...prev, [name]: value }));

//     };
//     return (
//         <div className="contain" key={login}>
//             <div className="left ">
//                 <img src={Tsslogo} alt="" className="logo animate-left" />
//                 <div className="bike animate-left"><img src={bike} alt="" />
//                 </div>
//                 <div className="logo-secion animate-left">
//                     <div className="logo-name">TRACK N TRACK COUIRER SERVICES</div>
//                     <div className="logo-text">Track N Track Courier Services is a next-gen tech-driven express and
//                         e-commerce Logistics solution provider.</div>
//                 </div>
//             </div>
//             <div className="right">
                
//                 <div className="form-page">
//                     <div className="mobile-logo animate-rtl">
//         <img src={Tsslogo} alt="Logo" />
//     </div>
//                     <div className="tital animate-rtl">{login ? "Login Page" : "Signup Page"}</div>
//                     <form className="form"
//                         onSubmit={(e) => {
//                             e.preventDefault();
//                             if (login) {
//                                 handleSaveLogin(e);
//                             }
//                         }}
//                     >
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="user">User Name</label>
//                             <input type="text" id="userName" name="userName" placeholder="Enter User name"
//                                 value={formData.userName}
//                                 onChange={handleInputChange} />
//                             <FaUser className="userLogo" />
//                         </div>
//                         <div className="input-div animate-rtl">
//                             <label htmlFor="pass">Password</label>
//                             <input type={!lock ? "text" : "password"} id="password" name="password" placeholder="Enter Password"
//                                 value={formData.password}
//                                 onChange={handleInputChange} />
//                             <div onClick={() => setLock(p => !p)}>{!lock ? <IoLockOpen className="passLogo" /> :
//                                 <IoLockClosed className="passLogo" />}</div>
//                         </div>
//                         <button className="animate-rtl button" >{login ? "Login" : "Signup"}</button>
//                     </form>
//                     <div className="account">{login ? "Don't have an account ?" : "Already Registered ?"}
//                         <span onClick={() => setLogin((p) => !p)}>{login ? "Signup" : "Login"}</span></div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Login




// ==============================SHREE RAM JI COURIER AND LOGISTICS ============================



import "./Login1.css";
import { useState } from "react";
import { IoLockOpen, IoLockClosed } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import bike from "../../Assets/Images/LOGO.png"
import logo from "../../Assets/Images/LOGO.jfif"
// import Aslogistics from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// import ShreeRamLogo from "../../Assets/Images/Clientlogo/ShreeRamjiLogistics_Logo.png"
// import AGLlogo from "../../Assets/Images/Clientlogo/Agl_logo.png"
// import Tsslogo from "../../Assets/Images/Clientlogo/Tsslogo.png"
import Tsslogo from "../../Assets/Images/Clientlogo/Shreeramjilogo.png"

import Swal from "sweetalert2";
import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import { useNavigate } from "react-router-dom";
const Login = () => {
    const navigate = useNavigate();
    const [login, setLogin] = useState(true);
    const [lock, setLock] = useState(true);
    
    const [formData, setFormData] = useState({ userName: "", password: "" });
    const handleSaveLogin = async (e) => {
        e.preventDefault();

        const { userName, password } = formData;

        if (!userName || !password) {
            Swal.fire("Error", "Username and Password are required", "error");
            return;
        }

        try {
            const response = await getApi(
                `/Master/UserContllor?UserName=${encodeURIComponent(
                    userName
                )}&Password=${encodeURIComponent(password)}`
            );

            if (response.status === 1) {
                Swal.fire({
          title: "Success",
          text: "Login successful!",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
                localStorage.setItem("Login", JSON.stringify(response.userData));

                // ✅ HASHROUTER SAFE
                navigate("/dashboard");
            } else {
                Swal.fire("Error", "Invalid credentials", "error");
            }
        } catch (err) {
            console.error("Login Error:", err);
            Swal.fire(
                "Error",
                "Invalid username or password. Please try again.",
                "error"
            );
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

    };
    return (
        <div className="contain" key={login}>
            <div className="left ">
                <img src={Tsslogo} alt="" className="logo animate-left" />
                <div className="bike animate-left"><img src={bike} alt="" />
                </div>
                <div className="logo-secion animate-left">
                    <div className="logo-name">SHREE RAM JI COURIER & LOGISTICS</div>
                    <div className="logo-text">Shree Ram Ji Courier & Logisticsis a next-gen tech-driven express and
                        e-commerce Logistics solution provider.</div>
                </div>
            </div>
            <div className="right">
                
                <div className="form-page">
                    <div className="mobile-logo animate-rtl">
        <img src={Tsslogo} alt="Logo" />
    </div>
                    <div className="tital animate-rtl">{login ? "Login Page" : "Signup Page"}</div>
                    <form className="form"
                        onSubmit={(e) => {
                            e.preventDefault();
                            if (login) {
                                handleSaveLogin(e);
                            }
                        }}
                    >
                        <div className="input-div animate-rtl">
                            <label htmlFor="user">User Name</label>
                            <input type="text" id="userName" name="userName" placeholder="Enter User name"
                                value={formData.userName}
                                onChange={handleInputChange} />
                            <FaUser className="userLogo" />
                        </div>
                        <div className="input-div animate-rtl">
                            <label htmlFor="pass">Password</label>
                            <input type={!lock ? "text" : "password"} id="password" name="password" placeholder="Enter Password"
                                value={formData.password}
                                onChange={handleInputChange} />
                            <div onClick={() => setLock(p => !p)}>{!lock ? <IoLockOpen className="passLogo" /> :
                                <IoLockClosed className="passLogo" />}</div>
                        </div>
                        <button className="animate-rtl button" >{login ? "Login" : "Signup"}</button>
                    </form>
                    <div className="account">{login ? "Don't have an account ?" : "Already Registered ?"}
                        <span onClick={() => setLogin((p) => !p)}>{login ? "Signup" : "Login"}</span></div>
                </div>
            </div>
        </div>
    )
}

export default Login
